import type { ValidationFunctionBasic, ValidationRule } from '../types';

export const requiredFn: ValidationFunctionBasic<unknown> = (value) => {
  if (value === undefined || value === null) {
    return false;
  }
  if (typeof value === 'string' && value.trim().length === 0) {
    return false;
  }
  return true;
};

export const required = {
  fn: requiredFn,
  messageKey: 'empty',
} as ValidationRule<unknown>;
